export const COLLECTIONS_BY_CUSTOMER_CHANGE_TRACKING = {
  updateRiskPercent: {
    source: 'collections_by_customer.update_risk_percent',
    id: 19001,
  },
  applyActions: {
    source: 'collections_by_customer.apply_actions',
    id: 19002,
  },
  assignTier: {
    source: 'collections_by_customer.assign_tier',
    id: 19003,
  },
  assignKeyReason: {
    source: 'collections_by_customer.assign_key_reason',
    id: 19004,
  },
  updateNextActionDate: {
    source: 'collections_by_customer.update_next_action_date',
    id: 19005,
  },
  addComment: {
    source: 'collections_by_customer.comments.add',
    id: 19101,
  },
  editComment: {
    source: 'collections_by_customer.comments.edit',
    id: 19102,
  },
  deleteComment: {
    source: 'collections_by_customer.comments.delete',
    id: 19103,
  },
  collectionFlagCreate: {
    source: 'collections_by_customer.collection_flag.create',
    id: 19201,
  },
  collectionFlagUpdate: {
    source: 'collections_by_customer.collection_flag.update',
    id: 19202,
  },
  collectionFlagDelete: {
    source: 'collections_by_customer.collection_flag.delete',
    id: 19203,
  },
} as const;
